import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import CheckboxV2 from '../../common/inputs/checkbox-v2';
import { ReactionIcon } from './ReactionIcon/ReactionIcon';
import TextInput from '../../topics/components/TextInput';
import React, { useState } from 'react';

// TODO display translation appropriate to spot language
const DEFAULT_REACTION_NAMES_EN = {
  happy: 'Happy',
  surprised: 'Surprised',
  sad: 'Sad',
  angry: 'Angry'
};

const DragHandle = SortableHandle(() => {
  return (
    <svg
      className="reaction-settings-grab-handle-icon"
      height="1em"
      viewBox="0 0 6 13"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="currentColor">
        <circle id="Oval" cx="1.795" cy="1.75" r="1" />
        <circle id="Oval" cx="1.795" cy="4.893" r="1" />
        <circle id="Oval" cx="1.795" cy="8.036" r="1" />
        <circle id="Oval" cx="4.795" cy="1.75" r="1" />
        <circle id="Oval" cx="4.795" cy="4.893" r="1" />
        <circle id="Oval" cx="4.795" cy="8.036" r="1" />
        <circle id="Oval" cx="1.795" cy="11.179" r="1" />
        <circle id="Oval" cx="4.795" cy="11.179" r="1" />
      </g>
    </svg>
  );
});

export const SortableReaction = SortableElement(
  ({
    reaction,
    onSettingsChange,
    spotId
  }) => {
    const [hasIconUploadError, setHasIconUploadError] = useState(false);
    const shouldShowIconReset = reaction.name === null && reaction.custom_image_id === null;
    return (
      <article className="articleReactionsSettingsItem" key={reaction.id}>
        <div className="reaction-settings-item-handle-checkbox-container">
          <DragHandle />
          <CheckboxV2
            className="reaction-settings-item-checkbox"
            id={`reaction-settings-item-checkbox-${reaction.id}`}
            checked={reaction.is_active}
            onChange={isChecked =>
              onSettingsChange(reaction.id, {
                is_active: isChecked
              })
            }
          />
        </div>

        <ReactionIcon
          reactionId={reaction.id}
          title={reaction.name}
          customImageId={reaction.custom_image_id}
          spotId={spotId}
          onCustomImageChange={customImageId => onSettingsChange(reaction.id, { custom_image_id: customImageId })}
          onErrorStatusChange={(newStatus) => setHasIconUploadError(newStatus)}
        />

        <TextInput
          hideTitle
          value={reaction.name === null ? DEFAULT_REACTION_NAMES_EN[reaction.id] : reaction.name}
          isDefaultValue={reaction.name === null}
          validatior={() => true}
          maxLength={12}
          onChange={newName => onSettingsChange(reaction.id, { name: newName })}
          error={hasIconUploadError}
        />
        {hasIconUploadError && (
          <div className="icon-file-error">
            Please upload an image with a square aspect ratio up to 100kb
          </div>
        )}
        {!hasIconUploadError && (
          <button
            className={`reaction-reset-reaction-name-action btn-link ${
              shouldShowIconReset ? 'is-hidden' : ''
            }`}
            onClick={() => onSettingsChange(reaction.id, { name: null, custom_image_id: null })}
          >
            Reset to Default
          </button>
        )}
      </article>
    );
  }
);

export const SortableReactionsContainer = SortableContainer(({ children }) => {
  return <div className="reaction-settings-list">{children}</div>;
});
